import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import Delta from 'quill-delta';

@Component({
    selector: 'ngf-delta-viewer',
    templateUrl: './ngf-delta-viewer.component.html',
    styleUrl: './ngf-delta-viewer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NgfDeltaViewerComponent {

  @Input()
  content!: Delta;

}
